var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xl-2"},[_c('div',{staticClass:"tile-frame left-aligned h-1"},[_c('router-link',{attrs:{"to":{
        name: this.routerName,
      }}},[_c('div',{staticClass:"tile inverted",class:_vm.color},[_c('div',{staticClass:"icon-container fa-container"},[_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":_vm.icon,"fixed-width":"","transform":"right-2 shrink-3"}})],1),_c('div',{staticClass:"title"},[_c('div',[_vm._v(_vm._s(this.auswahlwerte))])])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }